import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import MosqueCard from "./MosqueCard";
import PaginationControls from "../common-component/PaginationControls";
import DisclaimerAlert from "../common-component/DisclaimerAlert";

const MosqueList = ({
  mosques,
  countryId,
  onNextPage,
  onPrevPage,
  hasMore,
  offset,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid item xs={12}>
        <DisclaimerAlert message="Please note that the images used below are for demonstration purposes only and do not represent the actual mosques." />
      </Grid>
      {mosques?.length === 0 ? (
        <Typography
          variant="body1"
          sx={{
            fontFamily: "Poppins, sans-serif",
            textAlign: "center",
            my: 4,
          }}
        >
          No mosques found for this country or prefecture
        </Typography>
      ) : (
        <>
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: { xs: "center", sm: "flex-start" },
              "& > .MuiGrid-item": {
                display: "flex",
                justifyContent: "center",
              },
            }}
          >
            {mosques?.map((mosque) => (
              <Grid item xs={12} sm={6} md={6} lg={4} key={mosque._id}>
                <MosqueCard mosque={mosque} countryId={countryId} />
              </Grid>
            ))}
          </Grid>
          <Box sx={{ mt: 4, mb: 2, display: "flex", justifyContent: "center" }}>
            <PaginationControls
              onPrev={onPrevPage}
              onNext={onNextPage}
              hasMore={hasMore}
              offset={offset}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default MosqueList;
